module.exports = __webpack_public_path__ + "media/images/logos/Yahoo-Finance-logo-93a62a279ef7cae813191b1f839d15b9.svg";